<template>
  <section id="match-progress" class="match-progress-section">
    <div class="progress-decoration">
      <div class="progress-red-sun"></div>
      <div class="progress-mask"></div>
    </div>

    <div class="progress-shell">
      <div class="progress-title">
        <img :src="matchProgressSectionData.titleImage" alt="赛事进程" />
      </div>

      <div class="progress-board">
        <div class="tabs-container">
          <div class="progress-tabs">
            <div v-for="tab in matchProgressSectionData.tabs" :key="tab.id" class="progress-tab"
              :class="{ active: activeTab === tab.id }" @click="changeActiveTab(tab.id)">
              <img :src="activeTab === tab.id ? tab.imageActive : tab.image" :alt="tab.title" />
            </div>
          </div>

          <div class="progress-table-shell">
            <Transition name="progress-content" mode="out-in">
              <div v-if="activeTab === 'ranking'" key="ranking" class="ranking-table">
                <div class="ranking-table-container">
                  <div class="ranking-table-header">
                    <div v-for="header in matchProgressSectionData.rankingHeaders" :key="header" class="ranking-cell">
                      {{ header }}
                    </div>
                  </div>

                  <div class="ranking-table-body">
                    <div v-for="(item, index) in currentRankingList" :key="item.team" class="ranking-row">
                      <div class="ranking-cell">{{ (currentPage - 1) * matchProgressSectionData.rankingPageSize + index + 1 }}</div>
                      <div class="ranking-cell">{{ item.team }}</div>
                      <div class="ranking-cell">{{ item.score }}</div>
                      <div class="ranking-cell">{{ item.winRate }}</div>
                    </div>
                    <div v-if="!currentRankingList.length" class="ranking-empty">暂无战队</div>
                  </div>
                </div>

                <MatchPagination
                  v-if="currentRankingList.length"
                  :current-page="currentPage"
                  :total-pages="totalPages"
                  @change="changePage"
                />
              </div>

              <div v-else key="battle" class="battle-list">
                <div class="battle-mode-list">
                  <div
                    v-for="mode in matchProgressSectionData.battleModes"
                    :key="mode.id"
                    class="battle-mode"
                    :class="{ active: activeBattleMode === mode.id }"
                    @click="activeBattleMode = mode.id"
                  >
                    {{ mode.title }}
                  </div>
                </div>

                <img
                  class="battle-map"
                  v-if="currentBattleMode.image"
                  :src="currentBattleMode.image"
                  :alt="currentBattleMode.title"
                  @click="openBattleMapPreview"
                />
              </div>
            </Transition>
          </div>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
import { ImagePreview } from 'vant'
import MatchPagination from '@/components/match/common/MatchPagination.vue'
import { matchProgressSectionData, sortRankingListByScore } from '@/data/match/matchProgress'

export default {
  name: 'MatchProgressSection',
  components: { MatchPagination },
  data() {
    return {
      matchProgressSectionData,
      activeTab: 'ranking',
      activeBattleMode: 'imperial-tomb',
      currentPage: 1,
    }
  },
  computed: {
    currentBattleMode() {
      return this.matchProgressSectionData.battleModes.find(mode => mode.id === this.activeBattleMode)
        || this.matchProgressSectionData.battleModes[0]
    },
    sortedRankingList() {
      return sortRankingListByScore(this.matchProgressSectionData.rankingList)
    },
    totalPages() {
      return Math.ceil(this.sortedRankingList.length / this.matchProgressSectionData.rankingPageSize)
    },
    currentRankingList() {
      const startIndex = (this.currentPage - 1) * this.matchProgressSectionData.rankingPageSize
      return this.sortedRankingList.slice(startIndex, startIndex + this.matchProgressSectionData.rankingPageSize)
    },
  },
  methods: {
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) this.currentPage = page
    },
    changeActiveTab(tabId) { this.activeTab = tabId },
    openBattleMapPreview() {
      ImagePreview({
        images: [this.currentBattleMode.image],
        startPosition: 0,
        closeable: true,
        closeOnClickImage: false,
        closeOnClickOverlay: true,
        showIndicators: false,
        showIndex: false,
        minZoom: 1,
        maxZoom: 4,
        doubleScale: true,
      })
    },
  },
}
</script>

<style scoped lang="scss">
.match-progress-section {
  position: relative;
  min-height: 5.625rem;
  padding: 0 0 0;
  background: #f1f2f4 url('@/assets/image/match/pc/match/progress-section-bg.png') center top no-repeat;
  background-size: cover;
  box-sizing: border-box;

  .progress-decoration {
    position: absolute;
    z-index: 0;
    inset: 0;
    pointer-events: none;

    .progress-red-sun,
    .progress-mask {
      position: absolute;
    }
  }

  .progress-red-sun {
    z-index: 0;
    top: -0.802083rem;
    right: 0rem;
    width: 2.5rem;
    height: 2.5rem;
    background: url('@/assets/image/match/pc/match/progress-red-sun.png') center no-repeat;
    background-size: cover;
  }

  .progress-mask {
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    height: 6.666667rem;
    background: url('@/assets/image/match/pc/match/progress-mask.png') center top no-repeat;
    background-size: cover;
  }

  .progress-shell {
    position: relative;
    z-index: 2;
    width: 100%;
    max-width: 100%;
    margin: 0 auto;
  }

  .progress-title,
  .progress-board {
    margin-left: auto;
    margin-right: auto;
  }

  .progress-title {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 6.880208rem;
    height: 0.875rem;

    img {
      display: block;
      width: 6.880208rem;
      height: 0.875rem;
      object-fit: contain;
    }
  }

  .progress-board {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 8.151042rem;
    height: 4.328125rem;
    margin-top: 0.036458rem;
    background: url('@/assets/image/match/pc/match/progress-frame.png') center no-repeat;
    background-size: cover;
    box-sizing: border-box;

    .tabs-container {
      width: calc(6.755208rem + 0.34375rem);
      display: flex;
      align-items: center;


      .progress-tabs {
        display: flex;
        flex-direction: column;
        gap: 0.192708rem;
        width: 0.90625rem;
        margin-right: 0.359375rem;
        padding-bottom: 0.15625rem;

        .progress-tab {
          width: 0.90625rem;
          height: 1.427083rem;
          cursor: pointer;

          img {
            display: block;
            width: 0.90625rem;
            height: 1.427083rem;
            object-fit: cover;
          }
        }
      }

      .progress-table-shell {
        width: 5.489583rem;
        height: 100%;
      }
    }


  }

  .ranking-table {
    width: 5.489583rem;
    height: 100%;
    box-sizing: border-box;
    .ranking-table-container {
      height: 3.072917rem;
    }
    .ranking-table-header,
    .ranking-row {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      width: 5.489583rem;
    }

    .ranking-empty {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      color: #32516e;
      font-size: 0.125rem;
    }

    .ranking-table-header {
      height: 0.364583rem;
      background: #32516e;
      color: #ffffff;
      font-size: 0.130208rem;
      font-weight: bold;
      line-height: 0.364583rem;
    }

    .ranking-table-body {
      height: 2.708333rem;
    }

    .ranking-row {
      height: 0.270833rem;
      color: #000000;
      font-size: 0.09375rem;
      line-height: 0.270833rem;

      &:nth-child(even) {
        background: rgba(60, 86, 113, 0.5);
      }
    }

    .ranking-cell {
      height: inherit;
      line-height: inherit;
      overflow: hidden;
      text-align: center;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

  }

  .battle-list {
    width: 5.489583rem;
    height: 4.328125rem;
    padding-top: 0.647917rem;
    box-sizing: border-box;

    .battle-mode-list {
      display: flex;
      gap: 0.354167rem;
      width: 4.895833rem;
      height: 0.364583rem;
      margin: 0 auto;
    }

    .battle-mode {
      width: 0.958333rem;
      height: 0.364583rem;
      border: 0.010417rem solid transparent;
      border-radius: 0.052083rem;
      background: rgba(60, 86, 113, 0.5);
      box-sizing: border-box;
      color: #32516e;
      cursor: pointer;
      font-size: 0.15625rem;
      font-weight: bold;
      line-height: 0.34375rem;
      text-align: center;

      &.active {
        border-color: #15395c;
        background: #32516e;
        color: #dcccb6;
      }
    }

    .battle-map {
      display: block;
      width: 5.359375rem;
      height: 2.927083rem;
      // margin: 0.125rem auto 0;
      cursor: pointer;
      object-fit: contain;

    }
  }

  .progress-content-enter-active,
  .progress-content-leave-active {
    transition: opacity 280ms ease, transform 280ms ease;
  }

  .progress-content-enter-from,
  .progress-content-leave-to {
    opacity: 0;
    transform: translateY(0.0625rem);
  }
}

@media (max-width: 750px) {
  .match-progress-section {
    min-height: auto;
    padding: 0vw;
    background: transparent;

    .progress-decoration {
      display: none;
    }

    .progress-title {
      width: 90%;
      height: auto;

      img {
        width: 100%;
        height: auto;
      }
    }

    .progress-board {
      width: 100%;
      height: auto;
      margin-top: 2vw;
      background: none;
      align-items: stretch;
    }

    .progress-board .tabs-container {
      width: 100%;
      display: block;
    }

    .progress-board .tabs-container .progress-tabs {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 2vw;
      width: 50%;
      margin: 0 auto 3vw;
      padding-bottom: 0;
    }

    .progress-board .tabs-container .progress-tabs .progress-tab {
      width: 100%;
      height: auto;

      img {
        width: 100%;
        height: auto;
      }
    }

    .progress-board .tabs-container .progress-table-shell {
      width: 95%;
      height: auto;
      margin: 0 auto;
    }

    .ranking-table {
      width: 100%;
      height: auto;
      padding: 3vw;
      border-radius: 2.5vw;
      background: rgba(255, 255, 255, 0.72);

      .ranking-table-container {
        height: auto;
      }

      .ranking-table-header,
      .ranking-row {
        width: 100%;
        grid-template-columns: 16vw minmax(0, 1fr) 17vw 17vw;
      }

      .ranking-table-header {
        height: 10vw;
        font-size: 3vw;
        line-height: 10vw;
      }

      .ranking-table-body {
        height: auto;
      }

      .ranking-empty {
        min-height: 36vw;
        font-size: 3.2vw;
      }

      .ranking-row {
        height: 9vw;
        font-size: 2.7vw;
        line-height: 9vw;
      }

    }

    .battle-list {
      display: block;
      width: 100%;
      height: auto;
      padding-top: 0;
    }

    .battle-list .battle-mode-list {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 2.5vw;
      width: 90%;
      height: auto;
      margin: 0 auto;
    }

    .battle-list .battle-mode {
      width: 100%;
      height: 10vw;
      border-radius: 1.5vw;
      font-size: 3.2vw;
      line-height: 9.2vw;
    }

    .battle-list .battle-map {
      width: 90%;
      height: auto;
      margin: 4vw auto 0;
      border-radius: 2vw;
      background: rgba(255, 255, 255, 0.72);
    }

  }
}
</style>
